// Utility data
import { NUMBERS, SYMBOLS } from "./GeneralData";

// Validation Helper Object
const ApplicationHelper = {
    // General Input Validations
    filterNumbersAndSymbols(input) {
        for (let i = 0; i < input.length; i++) {
            if (NUMBERS.includes(input[i]) || SYMBOLS.includes(input[i])) {
                return false;
            }
        }
        return true;
    },

    checkInputForSymbol(input) {
        return SYMBOLS.includes(input) ? true : false;
    },

    verifyIsMinor(birthday) {
        const [month, day, year] = birthday.split('/');
        const birthDate = new Date(`${year}-${month}-${day}`);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        return age < 18;
    },

    verifyIsNumber(input) {
        for (let i = 0; i < input.length; i++) {
            if (!NUMBERS.includes(input[i])) {
                return false;
            }
        }
        return true;
    },

    // Input verifications

    // Personal Info
    verifyFirstName(firstName) {
        return firstName.length >= 2 && firstName.length <= 50;
    },

    verifyLastName(lastName) {
        return lastName.length >= 2 && lastName.length <= 50;
    },

    verifyFullName(fullName) {
        return fullName.length >= 2 && fullName.length <= 100;
    },

    verifyBirthday(birthday) {
        return birthday.length === 10;
    },

    verifyEmail(email) {
        return email.includes('@') && email.includes('.') && email.length > 6 && email.length < 45;
    },

    verifyPhone(phone) {
        return phone.length === 14;
    },

    verifyIncome(income) {
        return income.length !== 0 && income.length < 10 && this.verifyIsNumber(income);
    },

    // Family Info
    verifyFamilyInformationEntry(entry) {
        return entry.name.length >= 2 && entry.relation && entry.birthday.length === 10;
    },

    verifyFamilyInformation(familyInformation) {
        for (const entry of familyInformation) {
            if (!this.verifyFamilyInformationEntry(entry)) {
                return false;
            }
        }
        return true;
    },

    // Address
    verifyStreetAddress(streetAddress) {
        return streetAddress.length > 0 && streetAddress.length < 50;
    },

    verifyCity(city) {
        return city.length > 0 && city.length < 30;
    },

    verifyZip(zip) {
        return zip.length === 5 && this.verifyIsNumber(zip);
    },

    // Medical Info
    verifyHTC(HTC) {
        return HTC.length > 0 && HTC.length < 30;
    },

    // Info Section
    verifyAmount(amount) {
        return amount.length !== 0 && amount.length < 10 && this.verifyIsNumber(amount);
    },

    verifyDetails(details) {
        return details.length > 0 && details.length <= 1500;
    },

    verifyOtherLocations(otherLocations) {
        return otherLocations.length > 0 && otherLocations.length < 150;
    },

    verifyReferrer(referrer) {
        return referrer.length > 0 && referrer.length < 150;
    }
};

export default ApplicationHelper;
